import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import CcList from "../../ccList";
import CcButton from "../../ccButton";

const CalendarHours = ({ day, date, selectedTime, setTime, setSeparately, global }) => {
  const isAvailable = typeof(day?.disabled) === "boolean" ? !day?.disabled : false;
  const [intervals, setIntervals] = useState(null);

  useEffect(() => {
    if (!isAvailable) return;
    const intervalBase = setSeparately ? day : global;
    const tmp = {
      array: [],
      startTime: DateTime.fromISO(new Date(date).toISOString()).set({
        hour: intervalBase.from.split(":")[0],
        minutes: intervalBase.from.split(":")[1],
      }).reconfigure({ locale: "en-US" }),
      endTime:  DateTime.fromISO(new Date(date).toISOString()).set({ 
        hour: intervalBase.to.split(":")[0],
        minutes: intervalBase.to.split(":")[1],
      }).minus({ minutes: intervalBase.frequency}).reconfigure({ locale: "en-US" }),
      currentIteration: undefined,
    };
    tmp.currentIteration = tmp.startTime;

    while (tmp.endTime.diff(tmp.currentIteration, ["minutes"]).toObject().minutes >= 0) {
      tmp.array.push(tmp.currentIteration.toLocaleString(DateTime.TIME_SIMPLE));
      tmp.currentIteration = tmp.currentIteration.plus({ minutes: intervalBase.frequency });
    };

    setIntervals(tmp.array);
  }, [isAvailable, day, date, setSeparately, global]);

  return(
    isAvailable && intervals ? (
      <CcList>
        {intervals.map((h, index) => (
          <CcButton
            key={index}
            onClick={() => setTime(h)}
            isActive={selectedTime === h}
            label={h}
          />
        ))}
      </CcList>
    ) : (
      <p>Appointments are unavailable for this day, please select other date.</p>
    )
  );
};

export default CalendarHours;
